import React, { createContext, useContext, useEffect, useState } from 'react'
import { io } from 'socket.io-client'
import { BattleEvents } from '../constants'

const SocketContext = createContext()

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null)
  const [isConnected, setConnected] = useState(false)

  useEffect(() => {
    const initData = window.Telegram?.WebApp?.initData || null
    const newSocket = io(process.env.REACT_APP_BASE_SOCKET_URL, {
      auth: { initData },
      autoConnect: false,
    })

    newSocket.on('connect', () => {
      console.log('Socket connected:', newSocket.id)
      setConnected(true)
    })
    newSocket.on('disconnect', () => {
      console.log('Socket disconnected')
      setConnected(false)
    })
    newSocket.on(BattleEvents.ERROR, (error) => {
      console.log(error)
    })
    newSocket.on("error", (error) => {
      console.log("Socket error:", error)
    })

    setSocket(newSocket)

    return () => {
      newSocket.disconnect()
    }
  }, [])

  const joinGame = (userId, cards) => {
    if (!socket) throw new Error('Socket not initialized')
    socket.emit('join_game', { userId, cards })
  }
  const connectSocket = () => {
    console.log('Connecting to socket...')
    console.log('Socket:', socket)
    if (!socket.isConnected) socket.connect();
    setConnected(true);
  };
  const disconnectSocket = () => {
    console.log('Disconnecting from socket...')
    if (socket) {
      socket.disconnect()
    }
  }
  return (
    <SocketContext.Provider value={{ socket, isConnected, joinGame,connectSocket,disconnectSocket }}>
      {children}
    </SocketContext.Provider>
  )
}

export const useSocket = () => useContext(SocketContext)